import GenresList from './GenresList';

export default GenresList;
